import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MedclassButtonComponent } from '../../components/medclass-button/medclass-button.component';
import { Router } from '@angular/router';
import { environment } from "../../../environments/enviroment";
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-prev-card',
  standalone: true,
  imports: [
    CommonModule, 
    MedclassButtonComponent,
    MatIconModule
  ],
  templateUrl: './prev-card.component.html',
  styleUrl: './prev-card.component.css',
  encapsulation: ViewEncapsulation.None
})
export class PrevCardComponent implements OnInit{

  baseUrl: string = environment.baseUrl;
  @Input() categoria: string = '';
  @Input() tipoCard: string = '';
  @Input() backImg: any = 'exampleBackImage1.png';
  @Input() showCategoria: boolean = true;
  @Input() isContenidoEspecial: boolean = false;
  @Input() isPuntoCima: boolean = false;
  @Input() isListaReproduccion: boolean = false;
  @Input() areaTerArr: string[] = []; //para filtro Áreas Terapeúticas
  @Input() claseActual: number = 0; //para tira de contendio en masterclass
  @Input() secuencial: string = ''; //para tira de contendio en masterclass
  @Input() selectionMode: boolean = false;
  @Output() cardSelected = new EventEmitter<any>();
  @Input() dataCard: any = {
    titulo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. 1',
    autor: 'Dra. Nancy Rosales',
    descripcion: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aliquid alias quia, esse natus obcaecati iste repellendus beatae eius laudantium perferendis laboriosam rerum, recusandae debitis id explicabo? Soluta fuga veniam iusto?',
    duracion: '18 minutos',
    numReproducciones: '342',
    categoria:'Podcast',
    imagen:'exampleBackImage1.png',
    areaTer: [
       'Cardio',
       'Salud Femenina',
       'Respiratorio'
    ],
    fecha: '2023-01-19T22:56:42.000+00:00',
    idContenido: '123455677',
    total: '',
    progeso: '0%',
   }

   idNavegacion:string = '';

  get esCertificacion(): boolean {
    const categoria = this.dataCard.categoria;

    return this.dataCard.es_certificacion === true && ['Masterclass', 'MasterClass', 'masterclass'].includes(categoria);
  }

  get etiquetaCategoria(): string {
    return this.esCertificacion ? 'Certificación' : this.dataCard.categoria;
  }


  constructor( private route:Router ){}
  
  ngOnInit(): void {
    
    if (this.isListaReproduccion) {
      this.idNavegacion = this.dataCard._id;
    }else{
      this.idNavegacion = this.dataCard.id;
    }

    if (this.backImg != 'exampleBackImage1.png') {
      if (typeof(this.backImg) == 'object') {
        this.urlCardImage =  this.backImg.url;
        //console.log(this.urlCardImage);
        return

      }
      this.urlCardImage = this.limpiaUrlImagen(this.backImg);
    }
  }

  urlCardImage: string  = `../../../../assets/${this.backImg}`;
  // cardImage: string = `background-image: url(${this.urlCardImage})`;

  navToContenido( idContenido:string, categoria?:string ){
    // let categoriaContenido
    // if (categoria == 'lista-de-reproduccion') {
    //   categoriaContenido = categoria;
    // }else{
    //   //console.log(this.dataCard.categoria.toLowerCase());
    //   categoriaContenido = this.dataCard.categoria.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    // }
    // const url = `contenido/${categoriaContenido}/${idContenido}`;
    // //console.log(url);
    if (this.isListaReproduccion) {
      const tipoReal = this.dataCard.categoria.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const url = `contenido/lista-de-reproduccion/${tipoReal}/${idContenido}`;
      this.route.navigateByUrl(url);
      return;
    }

    const categoriaContenido = this.dataCard.categoria.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const url = `contenido/${categoriaContenido}/${idContenido}`;
    this.route.navigateByUrl(url);
  }

  handleActivation(event?: Event): void {
    if (this.tipoCard === 'tipo8') {
      return;
    }

    if (this.selectionMode) {
      event?.preventDefault();
      this.cardSelected.emit(this.dataCard);
      return;
    }

    this.navToContenido(this.idNavegacion, this.categoria);
  }

  handleKeydown(event: KeyboardEvent): void {
    if (!this.selectionMode || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    this.handleActivation(event);
  }

  // navToWebinar( idContenido:string ){
  //   const url = `webinar/${idContenido}`;
  //   //console.log(url);
  //   this.route.navigateByUrl(url);
  // }

  navToWebinar(idContenido: string) {
    const url = `/webinar/${idContenido}`;
    // Navegar y recargar la página completamente
    window.location.href = url;
  }

  limpiaUrlImagen(url:string) {
    // Reemplazar paréntesis izquierdo y derecho con sus equivalentes codificados
    const urlModificada = url.replace(/\(/g, '%28').replace(/\)/g, '%29');
    return urlModificada;
  }

}
